
<div class="media-card">
  <div class="card-thumbnail">
    @if (thumbnail) {
      <img class="image" [src]="thumbnail" [alt]="altText">
    }
  </div>
  <div class="media-card-text">
    <a href="javascript:void(0)" color="primary" class=""
      [ngClass]="" (click)="goToMediaLink()">
      <h5 class="title">{{title}}</h5>
    </a>
    <div class="sub-text">
      @for (tag of tags; track tag) {
        <span>
          {{tag}} |
        </span>
      }
      {{formattedDate}}
    </div>
    <p class="description">
      {{description}}
    </p>
  </div>
</div>

